import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
   selector: 'app-video-imovel',
   standalone: true,
   templateUrl: './video-imovel.component.html',
   styleUrl: './video-imovel.component.scss'
})
export class VideoImovelComponent {
   link: SafeResourceUrl = '';
   private popStateListener = () => this.fecharModal(true);

   constructor(
      public router: Router,
      public dialogRef: MatDialogRef<VideoImovelComponent>, // Referência do dialog para fechamento manual
      @Inject(MAT_DIALOG_DATA) public data: { url: string },
      private sanitizer: DomSanitizer
   ) {
      const embedUrl = this.getEmbedUrl(data.url);
      this.link = embedUrl ? this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl) : '';

      // Adiciona uma entrada no histórico ao abrir o diálogo
      history.pushState(null, '', location.href);

      // Escuta o botão de voltar do navegador
      window.addEventListener('popstate', this.popStateListener);

      // Remove o listener se o usuário fechar o modal manualmente
      this.dialogRef.afterClosed().subscribe(() => {
         window.removeEventListener('popstate', this.popStateListener);

         // Volta um passo no histórico (só se ainda não voltou)
         if (history.state === null) history.back();
      });
   }

   fecharModal(triggeredByBackButton = false) {
      // Fecha o modal e deixa o popstate limpar o histórico
      this.dialogRef.close();

      if (!triggeredByBackButton) {
         // Se o fechamento for manual (ex: botão fechar), volta no histórico
         history.back();
      }
   }

   getEmbedUrl(youtubeUrl: string): string | null {
      const videoID = this.getYouTubeVideoID(youtubeUrl);
      return videoID ? `https://www.youtube.com/embed/${videoID}` : null;
   }

   getYouTubeVideoID(url: string): string | null {
      const urlParams = new URLSearchParams(new URL(url).search);
      return urlParams.get('v');
   }
}
